import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FormValidation from './components/FormValidation';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
      <FormValidation />
  </div>
);
